import classNames from "classnames";
import React, { useMemo } from "react";
import { Slide, Fade, Zoom } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
// import "./styles/BackgroundSlider.css";

const EFFECt_MAPPING = {
    fade: Fade,
    zoom_out: Zoom,
    slide: Slide,
};

function BackgroundSlider({ data, style }) {
    // const images = [
    //     "https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
    //     "https://images.unsplash.com/photo-1506710507565-203b9f24669b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1536&q=80",
    //     "https://images.unsplash.com/photo-1536987333706-fc9adfb10d91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80",
    // ];

    const images = useMemo(() => {
        const imgArr = data.images || [];
        return imgArr.map((item) => {
            return item.full;
        });
    }, [data]);

    const slide_style = {
        // backgroundPosition: "center",
        backgroundAttachment: style.backgroundAttachment || "local",
    };

    let Effect = EFFECt_MAPPING[data.effect || "fade"];

    return (
        <div
            className={classNames(
                "q-image-slideshow-wrapper",
                style.backgroundPanning
            )}
        >
            <Effect
                scale={1.5}
                autoplay={true}
                duration={data.duration || 3000}
                transitionDuration={data.transitionDuration || 1000}
                cssClass="q-image-slideshow-slide"
                indicators={false}
                arrows={false}
            >
                {images.map((img) => {
                    return (
                        <div
                            key={img}
                            className={classNames(
                                "q-image-slideshow-slide-in",
                                "pan_h"
                            )}
                            style={{
                                backgroundImage: `url(${img})`,
                                ...slide_style,
                            }}
                        ></div>
                    );
                })}
            </Effect>
        </div>
    );
}

export default BackgroundSlider;
